const CallDetailsTranscript = ({
	transcript
}: {
	transcript: string
}) => {
	const messages = transcript
	.split(/\n(?=(?:AI|User):?\s*)/)
	.map(msg => msg.trim())
	.filter(Boolean);

	return (
		<div className="space-y-2 flex flex-col text-black dark:text-white text-sm font-normal">
			<h4 className="text-gray-500 font-medium mb-2">Transcript</h4>
			{messages.map((msg, idx) => {
				const isAI = /^AI:?\s*/.test(msg);
				const content = msg.replace(/^AI:?\s*|^User:?\s*/, '').trim();
				const speaker = isAI ? 'Claire' : 'User';

				return (
				<div
					key={idx}
					className={`p-2 rounded-md max-w-xs ${
					isAI ? ' self-start flex flex-row' : ' self-end bg-gray-100 rounded-3xl py-3 px-5'
					}`}
				>
					{isAI && <img src="/assets/agents/claire-agent-icon.svg" className="object-contain w-8 h-8 rounded-full mr-4" />}
					<div className="flex flex-col">
						<span className="text-xs text-gray-500 mb-1">{speaker}</span>
						<span>{content}</span>
					</div>
				</div>
				);
			})}
		</div>
	) 
}

export default CallDetailsTranscript;